<!-- eslint-disable no-undef -->
<script setup>
  import { useRoute } from 'vue-router';

  defineOptions({
    name: 'DomainSubnav'
  });

  const props = defineProps({
    items: {
      type: Array,
      default: () => []
    }
  });

  const route = useRoute();

  const isActive = (itemPath) => route.path.startsWith(itemPath);
</script>

<template>
  <nav
    class="flex min-h-[44px] items-center gap-2 overflow-x-auto bg-mc-ink px-4 py-2 text-mc-white"
    :style="{ borderBottom: '1px solid var(--line-on-dark)' }"
    aria-label="Domain sub-navigation"
  >
    <RouterLink
      v-for="item in props.items"
      :key="item.id"
      :to="item.to"
      class="whitespace-nowrap rounded-md px-3 py-1.5 text-sm text-white/82 transition-colors hover:bg-white/10 hover:text-white"
      :class="isActive(item.to) ? 'bg-white/10 text-white' : ''"
      :aria-current="isActive(item.to) ? 'page' : undefined"
    >
      {{ item.label }}
    </RouterLink>
  </nav>
</template>
